import { parsePurify } from '../../../utils/parsePurify';
import TripDetailsSubHeading from '../../tripDetailsSubHeading/TripDetailsSubHeading';

export default function Places({ data }) {
    return (
        <div>
            {data?.map((dayData, dayIndex) => {
                return (
                    <div key={dayIndex} className='detailsItineraryDiv'>
                        <TripDetailsSubHeading text={`${dayData.name}`} />
                        <div className='detailsItineraryDayDec'>
                            <span className='detailsItineraryDayDecSpan'>{parsePurify(dayData.description)}</span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
